/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Template } from '../../models/template';

export interface GetTemplateById$Plain$Params {

/**
 * template name
 */
  name?: string;

/**
 * template id
 */
  id: string;
}

export function getTemplateById$Plain(http: HttpClient, rootUrl: string, params: GetTemplateById$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Template>> {
  const rb = new RequestBuilder(rootUrl, getTemplateById$Plain.PATH, 'get');
  if (params) {
    rb.query('name', params.name, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Template>;
    })
  );
}

getTemplateById$Plain.PATH = '/api/Template/{id}';
